<!--
  BHIS doplňková mapová nástrojová nabídka 
-->
<template>

  <div class="d-flex flex-row" v-if="IsInit">

    <v-tooltip top>
      <template v-slot:activator="{ on, attrs }">
        <v-btn class="MapPnlGrdItem elevation-5" width="40" min-width="40" min-height="40" color="info" v-bind="attrs"
          v-on="on" @click="MapLayerLegendStaticSet()">
          <v-icon>mdi-map-legend</v-icon>
        </v-btn>
      </template>
      <span class="">Legenda</span>
    </v-tooltip>

    <v-card width="320" color="transparent" flat>
      <v-overflow-btn class="MapPnlGrdItem elevation-5 u_v-autocomplete " :items="Seznam01" v-model="VybSeznam01"
        item-text="Popis" return-object dense hide-details="true" background-color="info" height="40">
        <template v-slot:item="{ item, attrs, on }">
          <v-list-item v-bind="attrs" v-on="on">
            <v-list-item-avatar color="white" tile size="52">
              <v-img :src="AssetsUrl + '/img/map/mapa_NLI_Bhist_' + item.id + '.png'" />
            </v-list-item-avatar>
            <v-list-item-content>
              <v-list-item-title v-text="item.Popis" />
            </v-list-item-content>
          </v-list-item>
        </template>
      </v-overflow-btn>
    </v-card>

    <template v-if="VybSeznam01.Seznam.length > 0">
      <v-card width="300" color="transparent" flat>
        <v-overflow-btn class="MapPnlGrdItem elevation-5 u_v-autocomplete " :items="VybSeznam01.Seznam"
          v-model="VybSeznam02" item-text="Popis" return-object dense hide-details="true" height="40"
          background-color="info">
          <template v-slot:item="{ item, attrs, on }">
            <v-list-item v-bind="attrs" v-on="on">
              <v-list-item-content>
                <v-list-item-title v-text="item.Popis" />
                <v-list-item-subtitle v-text="item.PodPopis" />
              </v-list-item-content>
            </v-list-item>
          </template>
        </v-overflow-btn>
      </v-card>
    </template>

    <v-tooltip top>
      <template v-slot:activator="{ on, attrs }">
        <v-btn class="MapPnlGrdItem elevation-5" width="40" min-width="40" min-height="40" color="info" v-bind="attrs"
          v-on="on" @click="VybComp = 'MapMmpBhisInfo'">
          <v-icon>mdi-information-outline</v-icon>
        </v-btn>
      </template>
      <span class="">Informace</span>
    </v-tooltip>




  </div>
</template>

<script>
import AppJson from "../../../assets/MapOt_Bhis.json";

export default {

  components: {

  },


  props: {
    // Adresa na Assets
    AssetsUrl: null,
    // Mapová služba
    ServiceMap: null,
    // Mapa (Luciad)
    MAP: Object,
    // Měřítko vztažené k rovníku
    MapScale: null,
    // Mapové vrstvy
    MapLegendLayers: null,
    // Viditelnost legendy
    MapLayerLegend_view: null,

    // Seznam  komponent
    CompList: { type: Array },

  },

  data() {
    return {
      // Jestli je nástroj inicializován
      IsInit: false,

      // Seznam vrstev 01
      Seznam01: [],
      // Vybraná vrstva 01
      VybSeznam01: {
        "id": "",
        "Popis": "",
        "Seznam": []
      },
      // Id vybrané vrstvy se Seznamu 01
      VybSeznam01Id: null,
      // Vybraná vrstva 02
      VybSeznam02: {
        "id": "",
        "Popis": "",
        "Styl": ""
      },

      // Seznam načtených legend
      BhistStaticLegends: {},



    };
  },



  computed: {
    // Vrstva LayerGroup z mapy určené pro BHIS
    MapLayer_Nli_Bhis: function () {
      return this.MapLegendLayers.find((item) => item.id == "Nli_Bhis");
    },
    // Vrstva LayerGroup z mapy určené pro BHIS - viditelnost
    MapLayer_Nli_Bhis_visible: function () {
      return this.MapLayer_Nli_Bhis.layer.visible;
    },

    // Vrstva z šestiúhelníky pro BHIS
    MapLayer_Nli_Bhis_hex: function () {
      return this.MapLegendLayers.find((item) => item.id == "Nli_Bhis_hex");
    },

    // Podřízená vrstvy - wfs
    MapLayer_Nli_Bhis_wfs: function () {
      return this.MapLegendLayers.find((item) => item.id == "Nli_Bhis_wfs");
    },
    // wfs vrstva - layers
    MapLayer_Nli_Bhis_wfs_Wfslayers: function () {
      return "gmgml:bhist_mapa" + this.VybSeznam01.id;
    },
    // wfs vrstva - painterSettings
    MapLayer_Nli_Bhis_wfs_painterSettings: function () {

      if (this.VybSeznam01.Seznam.length > 0) {
        return this.VybSeznam02.painterSettings;
      } else {
        return this.VybSeznam01.painterSettings;
      }
    },

    // Id legendy vybrané mapy
    VybLegId: function () {
      if (this.VybSeznam01.Seznam.length > 0 && this.VybSeznam01.id != "01") {
        return "Bhist" + this.VybSeznam01.id + "_" + this.VybSeznam02.id
      } else {
        return "Bhist" + this.VybSeznam01.id
      }
    },

    // Název legendy vybrané mapy
    VybLegTitle: function () {
      if (this.VybSeznam01.Seznam.length > 0) {
        return this.VybSeznam01.Popis + "<br/><span class='text-body-2'>" + this.VybSeznam02.Popis + "</span>"
      } else {
        return this.VybSeznam01.Popis
      }
    },


    // Změna vybrané komponenty podle jména
    VybComp: {
      get() {
        return this.$store.getters.GET_sVybComp;
      },
      set(newValue) {
        this.$store.commit("SET_sVybComp", {
          CompName: newValue,
          SlotName: this.CompList.find((item) => item.name == newValue).slot,
        });
      },
    },




  },

  watch: {


    // Změna Seznam01
    VybSeznam01: function (value) {
      this.VybSeznam02 = value.Seznam[0];
    },

    // Změna Seznam02
    VybSeznam02: function (value) {
      this.ZmenaMapy(this.VybSeznam01, value);
    },

    // Změna viditelnosti Nli_Bhis
    MapLayer_Nli_Bhis_visible: function (value) {
      //console.log("MapLayer_Nli_Bhis_visible", value)
      if (value && (this.VybSeznam01.id == "02" || this.VybSeznam01.id == "03" || this.VybSeznam01.id == "04" || this.VybSeznam01.id == "05")) {
        this.MapLayer_Nli_Bhis_hex.layer.visible = true
      } else {
        this.MapLayer_Nli_Bhis_hex.layer.visible = false
      }
    },


  },

  methods: {
    // Nová mapová vrstva - volá se funkce v nadřazeném objektu
    MapLegendNewLayer: function (vMapLayerInstr, vMapLayerVisible) {
      this.$emit('MapLegendNewLayer', vMapLayerInstr, vMapLayerVisible);
    },

    // Statická mapová legenda - proměnná pro vybranou vrstvu - volá se funkce v nadřazeném objektu
    MapLayerLegendStaticSet: function () {
      this.$emit('MapLayerLegendStaticSet', this.VybLegId, this.VybLegTitle, this.BhistStaticLegends[this.VybLegId]);
    },




    ZmenaMapy: function (VybSeznam01) {

      // Změna legendy, když je zobrazena a došlo ke změně typu
      if (this.MapLayerLegend_view) {
        this.MapLayerLegendStaticSet();
      }

      if (VybSeznam01.id == this.VybSeznam01Id) {
        // Změna mapy - VybSeznam02
        // Pouze změna Pointeru

        // console.log("ZmenaMapy VybSeznam02");

        this.MapLayer_Nli_Bhis.labelsub = this.VybSeznam02.Popis;
        this.MapLayer_Nli_Bhis_wfs.layer.painter.settings = (this.MapLayer_Nli_Bhis_wfs_painterSettings)

      } else {
        // Změna mapy - VybSeznam01
        // Nová vrstva

        if (this.VybSeznam01Id != null) {
          // console.log("Změna VybSeznam01");

          this.VybSeznam01Id = VybSeznam01.id;

          this.MapLayer_Nli_Bhis.label = this.VybSeznam01.Popis;
          this.MapLayer_Nli_Bhis.legend.image = "img/map/mapa_NLI_Bhist_" + this.VybSeznam01.id + ".png";

          if (this.VybSeznam01.Seznam.length > 0) {
            this.MapLayer_Nli_Bhis.labelsub = this.VybSeznam02.Popis;
          } else {
            this.MapLayer_Nli_Bhis.labelsub = null;
          }

          var WfsPredpis = AppJson.MapLayers.Nli_Bhis_wfs;
          WfsPredpis.opacity = this.MapLayer_Nli_Bhis.opacity;
          WfsPredpis.wfs.layers = this.MapLayer_Nli_Bhis_wfs_Wfslayers;
          WfsPredpis.featureOptions.painterSettings = this.MapLayer_Nli_Bhis_wfs_painterSettings;

          // šestiúhelníky
          if (this.MapLayer_Nli_Bhis_visible && (this.VybSeznam01.id == "02" || this.VybSeznam01.id == "03" || this.VybSeznam01.id == "04" || this.VybSeznam01.id == "05")) {
            this.MapLayer_Nli_Bhis_hex.layer.visible = true
          } else {
            this.MapLayer_Nli_Bhis_hex.layer.visible = false
          }

          this.MapLegendNewLayer(WfsPredpis, true)

        } else {
          // první načtení
          this.VybSeznam01Id = VybSeznam01.id;
        }

      }

    },




    // Načtení statické legendy
    NactiStaticMapLegend: function (id, Jmeno) {
      this.ServiceMap.MapLegend(Jmeno)
        .then((response) => {
          if (response.data.Dokonceno) {
            this.BhistStaticLegends[id] = response.data.Vypis;
          } else {
            return null;
          }
        })
        .catch((error) => {
          console.log(error);
        })
        .then(function () {
          // always executed
        });
    },




  },




  mounted() {
    // První spuštění nástroje
    // console.log("Bhis start");

    // Základní nastavení - 
    this.Seznam01 = AppJson.Seznam;
    // Načtení první vrstvy ze seznamu
    this.VybSeznam01 = this.Seznam01[0];

    // Nastavení vrstvy
    this.MapLayer_Nli_Bhis.label = this.VybSeznam01.Popis;
    this.MapLayer_Nli_Bhis.legend.image = "img/map/mapa_NLI_Bhist_" + this.VybSeznam01.id + ".png";

    // Vytvoření podřízených vrstev -  wfs
    // Změna parametrů předpisů podle první vrstvy
    AppJson.MapLayers.Nli_Bhis_wfs.wfs.layers = "gmgml:bhist_mapa" + this.VybSeznam01.id;
    if (this.VybSeznam01.Seznam.length > 0) {
      this.MapLayer_Nli_Bhis.labelsub = this.VybSeznam01.Seznam[0].Popis;
      AppJson.MapLayers.Nli_Bhis_wfs.featureOptions.painterSettings = this.VybSeznam01.Seznam[0].painterSettings;
      AppJson.MapLayers.Nli_Bhis_wfs.opacity = this.MapLayer_Nli_Bhis.opacity;
    } else {
      this.MapLayer_Nli_Bhis.labelsub = null;
      AppJson.MapLayers.Nli_Bhis_wfs.featureOptions.painterSettings = this.VybSeznam01.painterSettings;
      AppJson.MapLayers.Nli_Bhis_wfs.opacity = this.MapLayer_Nli_Bhis.opacity;
    }

    // Nové vrstvy
    this.MapLegendNewLayer(AppJson.MapLayers.Nli_Bhis_wfs, true)

    // Načtení legend
    this.Seznam01.forEach((value) => {
      if (value.Seznam.length > 0 && value.id != "01") {
        value.Seznam.forEach((value2) => {
          var legId = "Bhist" + value.id + "_" + value2.id
          this.NactiStaticMapLegend(legId, legId)
        })
      } else {
        var legId = "Bhist" + value.id
        this.NactiStaticMapLegend(legId, legId)
      }
    });

    // Objekt aktivován
    this.MAP.layerTree.whenReady().then(() => {
      this.IsInit = true;
    })

    // // Legenda vrstvy
    // this.MapLayerLegendDynamicAdd()

  },
};
</script>